/**
 * @description æ§ä»¶å±æ§å·¥å·ç±»å
 *
 * @export
 * @enum {number}
 */
export enum ControlPropertyToolType {
  /**
   * @description å±æ§
   */
  Property,
  /**
   * @description äºä»¶
   */
  Event,
  /**
   * @description éªè¯å¨
   */
  Validator
}
